import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import {
  faUserLock,
  faMoneyCheck,
  faMailBulk,
  faUser,
  faUsers,
  faCalendarAlt,
  faSignOut,
  faEyeSlash,
  faHome,
  faEye,
  faUpload,
  faArrowLeft,
  faPlus,
  faEdit,
  faCreditCard,
  faTrash,
  faBars,
  faExclamationTriangle,
  faTimes,
  faBell,
  faGears,
  faUserGroup,
  faClone,
  faCheckCircle,
  faExclamationCircle,
  faTimesCircle,
  faBriefcase,
  faFilter,
  faMagnifyingGlass,
  faPhone,
  faCalendarDays,
  faEnvelope,
  faRightToBracket,
  faXmarkCircle
} from "@fortawesome/free-solid-svg-icons";

library.add(faRightToBracket);
library.add(faCalendarDays);
library.add(faEnvelope);
library.add(faPhone);
library.add(faMagnifyingGlass);
library.add(faEye);
library.add(faFilter);
library.add(faEyeSlash);
library.add(faHome);
library.add(faCalendarAlt);
library.add(faUsers);
library.add(faUserLock);
library.add(faMoneyCheck);
library.add(faMailBulk);
library.add(faUser);
library.add(faSignOut);
library.add(faUpload);
library.add(faArrowLeft);
library.add(faPlus);
library.add(faEdit);
library.add(faTrash);
library.add(faBars);
library.add(faExclamationTriangle);
library.add(faTimes);
library.add(faBell);
library.add(faCheckCircle);
library.add(faExclamationCircle);
library.add(faTimesCircle);
library.add(faBriefcase);
library.add(faCreditCard);
library.add(faGears);
library.add(faUserGroup);
library.add(faClone);
library.add(faXmarkCircle);

export default FontAwesomeIcon;
